import {
    Alert,
    Icon,
    IconButton
} from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { StandardTable } from '../../_components/table/standard.table';
import { PaperTableHeader } from '../../_components/table/header.table';
import { TABLE_FILTER } from '../../_const/tableFilter.const';
import { handleErrorResponse } from '../../_helpers/handleResponse.helper';
import { SearchTableHeader } from '../../_components/table/search.table';
import { newsService } from '../../_services/news.service';
import { NewsManageDrawer } from './news-manageDrawer';
import { getDateString } from '../../_helpers/dateTime.helper';
import { NewsStatusEnum } from '../../_common/enum/newsStatus.enum';
import { DataTypeEnum } from '../../_common/enum/dataType.enum';

export function NewsIndex() {
    const [data, setData] = useState<any>({ items: [], count: 10 });
    const [filter, setFilter] = useState<any>({ ...TABLE_FILTER, orderBy: "statusId" });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const fetchData = async () => {
        setIsLoading(true);
        return await newsService.getAll(filter)
            .then(
                json => {
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [filter]);

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: 'Actions',
                size: 80,
                enableSorting: false,
                enableColumnFilter: false,
                Cell: ({ row }) => (
                    <IconButton
                        color="primary"
                        onClick={() => { navigate("Manage/" + row.original.id) }}>
                        <Icon>edit</Icon>
                    </IconButton>
                ),
            },
            {
                accessorKey: 'id',
                header: 'ID',
            },
            {
                accessorKey: 'newsCategoryName',
                header: 'Category',
            },
            {
                accessorKey: 'centreName',
                header: 'Centre',
            },
            {
                accessorKey: 'createdBy',
                header: 'Created By',
            },
            {
                accessorKey: 'createdDate',
                header: 'Created Date',
                Cell: ({ row }) => (
                    <>{!!row.original.createdDate ? getDateString(row.original.createdDate) : ""}</>
                ),
            },
            {
                accessorKey: 'isActive',
                header: 'Status',
                Cell: ({ row }) => (
                    <> {row.original.isActive ? "Active" : "Inactive"} </>
                )
            },
            {
                accessorKey: 'statusId',
                header: 'Request Status',
                accessorFn: (rowData: any) => <>
                    {
                        rowData.statusId == NewsStatusEnum.Pending ? <Alert severity="warning">{NewsStatusEnum[rowData.statusId]}</Alert> :
                            rowData.statusId == NewsStatusEnum.Approved ? <Alert severity="success">{NewsStatusEnum[rowData.statusId]}</Alert> :
                                rowData.statusId == NewsStatusEnum.Rejected ? <Alert severity="error">{NewsStatusEnum[rowData.statusId]}</Alert> :
                                    <></>}
                </>
            },
        ],
        []
    );

    return (
        <>
            <PaperTableHeader title="News" buttons={[
                { icon: "add", label: "Create", onClick: () => { navigate("Create") } }
            ]} />

            <SearchTableHeader inputs={[
                { label: "Category", name: "newsCategoryId", dataType: DataTypeEnum.NewsCategorys, onChange: setFilter, value: filter.newsCategoryId, width: 250 },
                { label: "Centre", name: "centreId", dataType: DataTypeEnum.Centres, onChange: setFilter, value: filter.centreId, width: 250 },

            ]} />

            <StandardTable
                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
            />

            <Routes>
                <Route path="Create" element={<NewsManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
                <Route path="Manage/:newsId" element={<NewsManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
            </Routes>

        </>
    );
}
